import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-trending-down",
  "use": "icon-trending-down-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-trending-down\" id=\"icon-trending-down\"><polyline points=\"23 18 13.5 8.5 8.5 13.5 1 6\" /><polyline points=\"17 18 23 18 23 12\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol